import BOSNoWrapText from 'Components/Generic/Misc/BOSNoWrapText';
import NoContentBox from 'Components/Generic/Misc/NoContentBox';
import OrgNameWithDrawerButton from 'Components/SiteDrawerContainer/OrgNameWithDrawerButton';
import TransIDWithDrawerButton from 'Components/SiteDrawerContainer/TransIDWithDrawerButton';
import VendorNameWithDrawerButton from 'Components/SiteDrawerContainer/VendorNameWithDrawerButton';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { formatMoney } from 'Util';
import { formatDate } from 'Util/dateUtil';
import styles from './TransactionList.module.css';

const tableColumnWidths = {
  id: 60,
  ref: 60,
  date: 72,
  org: 140,
  vendor: 140,
  amount: 80,
};

const TransactionList = ({ transactions }) => {
  let headers = (
    <tr className={styles.light_border_bottom}>
      <td className={styles.table_header_cell}>ID</td>

      <td className={styles.table_header_cell}>Ref #</td>

      <td style={{ textAlign: 'center' }} className={styles.table_header_cell}>
        Date
      </td>

      <td className={styles.table_header_cell}>Core</td>

      <td className={styles.table_header_cell}>Vendor</td>

      <td style={{ textAlign: 'right' }} className={styles.table_header_cell}>
        Amount
      </td>

      <td style={{ textAlign: 'right' }} className={styles.table_header_cell}>
        Cleared
      </td>
    </tr>
  );

  let totalColumns = 6;

  let transactionTableContent =
    !transactions ||
    (transactions.length === 0 && (
      <tr>
        <td colSpan={totalColumns}>
          <NoContentBox label='No Transactions' />
        </td>
      </tr>
    )) ||
    transactions.map((trans, index) => {
      return (
        <Fragment key={index}>
          <tr key={index} className={index % 2 ? styles.light_background : ''}>
            <td>
              <BOSNoWrapText maxWidth={tableColumnWidths.id} d>
                <TransIDWithDrawerButton transID={trans.id} />
              </BOSNoWrapText>
            </td>

            <td>
              <BOSNoWrapText maxWidth={tableColumnWidths.ref}>
                {trans.reference_number}
              </BOSNoWrapText>
            </td>

            <td style={{ textAlign: 'center' }}>
              <BOSNoWrapText maxWidth={tableColumnWidths.date}>
                {formatDate(trans.date_purchased)}
              </BOSNoWrapText>
            </td>

            <td>
              <BOSNoWrapText maxWidth={tableColumnWidths.org}>
                <OrgNameWithDrawerButton orgId={trans.parent_organization_id} />
              </BOSNoWrapText>
            </td>

            <td>
              <BOSNoWrapText maxWidth={tableColumnWidths.vendor}>
                <VendorNameWithDrawerButton vendorId={trans.vendor_id} />
              </BOSNoWrapText>
            </td>

            <td className={styles.money_cell}>
              <BOSNoWrapText maxWidth={tableColumnWidths.amount}>
                {`$${formatMoney(trans.display_amount)}`}
              </BOSNoWrapText>
            </td>

            <td className={styles.money_cell}>
              <BOSNoWrapText maxWidth={tableColumnWidths.amount}>
                {`$${formatMoney(trans.cleared_amount)}`}
              </BOSNoWrapText>
            </td>
          </tr>
        </Fragment>
      );
    });

  const totalAmount = transactions.reduce((acc, tr) => {
    return tr.display_amount ? acc + +tr.display_amount : acc;
  }, 0);

  const totalClearedAmount = transactions.reduce((acc, tr) => {
    return tr.cleared_amount ? acc + +tr.cleared_amount : acc;
  }, 0);

  return (
    <>
      <table className={styles.transaction_table}>
        <thead>{headers}</thead>
        <tbody>{transactionTableContent}</tbody>
        <tfoot>
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td className={styles.total_label_cell}> Total:</td>

            <td className={styles.money_cell}>
              <BOSNoWrapText maxWidth={tableColumnWidths.amount}>
                {`$${formatMoney(totalAmount)}`}
              </BOSNoWrapText>
            </td>

            <td className={styles.money_cell}>
              <BOSNoWrapText maxWidth={tableColumnWidths.amount}>
                {`$${formatMoney(totalClearedAmount)}`}
              </BOSNoWrapText>
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

TransactionList.propTypes = {
  transactions: PropTypes.array,
};

export default TransactionList;
